import React from "react";
import { Box, Button, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";
import InputGroupShape from "../../../../../../../../components/Inputs/InputGroupShape";

export default function ShellPanel() {
  const table = useMaterialReactTable({
    ...lightTable,
    data: [],
    columns: [
      {
        accessorKey: "c",
        header: "",
        size: 10,
      },
      {
        accessorKey: "Component",
        header: "Component",
        size: 60,
      },
      {
        accessorKey: "Inside DIameter (in)",
        header: "Inside DIameter (in)",
        size: 60,
      },
      {
        accessorKey: "Material",
        header: "Material",
        size: 60,
      },
      {
        accessorKey: "Can Length (in)",
        header: "Can Length (in)",
        size: 60,
      },
      {
        accessorKey: "long Seam Angle (Deg)",
        header: "long Seam Angle (Deg)",
        size: 60,
      },
      {
        accessorKey: "Provided",
        header: "Provided",
        size: 60,
      },
      {
        accessorKey: "3D Weight (lb)",
        header: "3D Weight (lb)",
        size: 60,
      },
    ],
  });

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Button variant="contained" sx={{ mr: 1 }}>
          <DeleteIcon />
        </Button>

        <Button variant="outlined">Update 3D</Button>
      </Box>

      <Grid container>
        <Grid item xs={6} sx={{ pt: 2 }}>
          <InputGroupShape name="Shell Details">
            <MaterialReactTable table={table} />
          </InputGroupShape>
        </Grid>
      </Grid>
    </>
  );
}
